import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ClassDto } from '@proxy/classes';
import { CourseClassesService } from '@proxy/courses';

@Component({
  selector: 'app-courses-audio-player',
  templateUrl: './courses-audio-player.component.html',
  styleUrls: ['./courses-audio-player.component.scss']
})
export class CoursesAudioPlayerComponent implements OnInit {
  @Input() class: ClassDto;
  @Input() fileStreamSource: string;
  @Input() tenantCourseId: string;
  @Output() classReviewed = new EventEmitter<void>();

  isLoading: boolean = false;
  private hasAudioEnded: boolean = false;

  constructor(private classesService: CourseClassesService) { }

  ngOnInit(): void { }

  onAudioEnded() {
    if (!this.hasAudioEnded && this.tenantCourseId) {
      this.hasAudioEnded = true;
      this.classesService.markAsReviewed(this.class.id, this.tenantCourseId).subscribe({
        complete: () => this.classReviewed.emit()
      });
    }
  }

}
